export const isPastDate = (isoDate: string): boolean => {
  const eventDate = new Date(isoDate);
  const currentDate = new Date();

  eventDate.setHours(0, 0, 0, 0);
  currentDate.setHours(0, 0, 0, 0);

  return eventDate < currentDate;
};